(function() {

  // -----------------------------------------------------------
  // CONFIGURATION — paste your deployed Apps Script URL here.
  // Copy it from the previous version before replacing this file.
  // -----------------------------------------------------------
  var APPS_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbzG306ehhcLp9uzoebdxBhS1ZGnHAz8YZXrfY3COeSNlXGCluu6XMRePK1PL0tZIIoARw/exec';

  // ---- DATA -------------------------------------------------

  var PROJECTS = [
    {label:'ALL',              code:'ALL'},
    {label:'New Construction', code:'NEW'},
    {label:'Retrofit',         code:'RETROFIT'}
  ];

  var WALLS_NEW = [
    {label:'All',          code:'ALL'},
    {label:'Wood Stud',    code:'WS'},
    {label:'Timber Frame', code:'TF'},
    {label:'Double Stud',  code:'DS'},
    {label:'Outrigger',    code:'OR'},
    {label:'Metal Framing',code:'MF'},
    {label:'Strawbale',    code:'SB'},
    {label:'Mass Timber',  code:'MT'}
  ];

  var WALLS_RETROFIT = [
    {label:'All',                                      code:'ALL'},
    {label:'Wood Retrofit [Interior construction]',    code:'WRi'},
    {label:'Wood Retrofit [Exterior construction]',    code:'WRx'},
    {label:'Masonry Retrofit [Interior construction]', code:'MRi'},
    {label:'Masonry Retrofit [Exterior construction]', code:'MRx'}
  ];

  var WALLS_BOTH = [
    {label:'All',                                      code:'ALL'},
    {label:'Wood Stud',                                code:'WS'},
    {label:'Wood Retrofit [Interior construction]',    code:'WRi'},
    {label:'Wood Retrofit [Exterior construction]',    code:'WRx'},
    {label:'Timber Frame',                             code:'TF'},
    {label:'Masonry Retrofit [Interior construction]', code:'MRi'},
    {label:'Double Stud',                              code:'DS'},
    {label:'Outrigger',                                code:'OR'},
    {label:'Metal Framing',                            code:'MF'},
    {label:'Strawbale',                                code:'SB'},
    {label:'Masonry Retrofit [Exterior construction]', code:'MRx'},
    {label:'Mass Timber',                              code:'MT'}
  ];

  var LOCS = [
    {label:'All',      code:'ALL'},
    {label:'Floors',   code:'B.F.UF'},
    {label:'Windows',  code:'W.H.J.S'},
    {label:'Skylights',code:'SK'},
    {label:'Doors',    code:'D'},
    {label:'Porches',  code:'PF.PR'},
    {label:'Garages',  code:'GF.GR'},
    {label:'Roofs',    code:'ROOF'}
  ];

  var CONFIGS = [
    {label:'All',        code:'ALL'},
    {label:'Flat',       code:'5'},
    {label:'Vaulted',    code:'6'},
    {label:'Warm attic', code:'7'},
    {label:'Cold attic', code:'8'}
  ];

  var ASSEMBLIES = [
    {label:'All',                          code:'ALL'},
    {label:'Vented 1" under sheathing',    code:'40'},
    {label:'Unvented w/ diffusion port',   code:'41'},
    {label:'Unvented w/ cont. insul.',     code:'42'},
    {label:'Vented single sheathing',      code:'43'},
    {label:'Vented double sheathing',      code:'44'}
  ];

  // ALL is first (left-most), DWG replaces CAD
  var FORMATS = [
    {label:'ALL', code:'ALL'},
    {label:'PDF', code:'PDF'},
    {label:'DWG', code:'DWG'}
  ];

  var WALL_LABELS = {
    'WS':'Wood Stud', 'WRi':'Wood Retrofit [Interior construction]',
    'WRx':'Wood Retrofit [Exterior construction]', 'TF':'Timber Frame',
    'MRi':'Masonry Retrofit [Interior construction]', 'DS':'Double Stud',
    'OR':'Outrigger', 'MF':'Metal Framing', 'SB':'Strawbale',
    'MRx':'Masonry Retrofit [Exterior construction]', 'MT':'Mass Timber'
  };
  var LOC_LABELS = {
    'B.F.UF':'Floors','W.H.J.S':'Windows','SK':'Skylights',
    'D':'Doors','PF.PR':'Porches','GF.GR':'Garages'
  };
  var CONFIG_LABELS   = {'5':'Flat','6':'Vaulted','7':'Warm attic','8':'Cold attic'};
  var ASSEMBLY_LABELS = {
    '40':'Vented 1" under sheathing','41':'Unvented w/ diffusion port',
    '42':'Unvented w/ cont. insul.','43':'Vented single sheathing',
    '44':'Vented double sheathing'
  };

  // ---- STATE ------------------------------------------------
  // All selections are now arrays (multi-select)
  var selProjects=[], selWalls=[], selLocs=[], selConfigs=[], selAssemblies=[], selFormats=[];
  var results = [];

  var FORM_FIELDS = ['field-first','field-last','field-email','field-phone','field-company','field-state','field-role'];

  // ---- HELPERS ----------------------------------------------

  function getActiveWalls() {
    var hasNew      = selProjects.indexOf('NEW')      !== -1;
    var hasRetrofit = selProjects.indexOf('RETROFIT') !== -1;
    if (hasNew && hasRetrofit) return WALLS_BOTH;
    if (hasNew)      return WALLS_NEW;
    if (hasRetrofit) return WALLS_RETROFIT;
    return WALLS_BOTH;
  }

  /**
   * Toggle an item in/out of arr.
   * If code === 'ALL': select all items in allCodes if not all selected,
   * otherwise deselect all.
   */
  function toggle(arr, code, allCodes) {
    if (code === 'ALL') {
      var allIn = allCodes.every(function(c) { return arr.indexOf(c) !== -1; });
      arr.splice(0, arr.length);
      if (!allIn) {
        for (var i = 0; i < allCodes.length; i++) arr.push(allCodes[i]);
      }
    } else {
      var idx = arr.indexOf(code);
      if (idx !== -1) arr.splice(idx, 1);
      else arr.push(code);
    }
  }

  function getCodeLabel(code) {
    var parts = code.split('.');
    var wall  = WALL_LABELS[parts[0]] || parts[0];
    if (parts[1]==='E' && parts[2] && parts[2].charAt(0)==='R') {
      var configNum = parts[2].slice(1);
      var config    = CONFIG_LABELS[configNum] || configNum;
      if (configNum==='5') return wall + ' — Roof / ' + config;
      return wall + ' — Roof / ' + config + ' / ' + (ASSEMBLY_LABELS[parts[3]] || parts[3]);
    }
    var locCode = parts.slice(1).join('.');
    return wall + ' — ' + (LOC_LABELS[locCode] || locCode);
  }

  function getBaseCode(entry) {
    var sep = entry.indexOf('::');
    return sep > -1 ? entry.slice(0, sep) : entry;
  }

  function getFormat(entry) {
    var sep = entry.indexOf('::');
    return sep > -1 ? entry.slice(sep + 2) : '';
  }

  /** Generate all detail codes from current multi-select state. */
  function generateCodes() {
    var codes = [];
    for (var wi = 0; wi < selWalls.length; wi++) {
      var w = selWalls[wi];
      for (var li = 0; li < selLocs.length; li++) {
        var loc = selLocs[li];
        if (loc !== 'ROOF') {
          codes.push(w + '.' + loc);
        } else {
          for (var ci = 0; ci < selConfigs.length; ci++) {
            var cfg = selConfigs[ci];
            if (cfg === '5') {
              codes.push(w + '.E.R5');
            } else {
              for (var ai = 0; ai < selAssemblies.length; ai++) {
                codes.push(w + '.E.R' + cfg + '.' + selAssemblies[ai]);
              }
            }
          }
        }
      }
    }
    return codes;
  }

  /** True when wall/location/config/assembly selections are complete (format not required). */
  function isDetailComplete() {
    if (selWalls.length === 0 || selLocs.length === 0) return false;
    if (selLocs.indexOf('ROOF') !== -1) {
      if (selConfigs.length === 0) return false;
      var hasNonFlat = selConfigs.some(function(c) { return c !== '5'; });
      if (hasNonFlat && selAssemblies.length === 0) return false;
    }
    return true;
  }

  /** True when ready to add to list (detail complete + at least one format). */
  function isAddable() {
    return isDetailComplete() && selFormats.length > 0;
  }

  function updateSendBtn() {
    var btn = document.getElementById('btn-send');
    if (!btn) return;
    var ok = FORM_FIELDS.every(function(id) {
      var el = document.getElementById(id);
      return el && el.value.trim();
    });
    btn.disabled = !ok;
  }

  /**
   * Render a multi-select chip row.
   * ALL chip is active when every non-ALL item is selected.
   * onToggle(code, nonAllCodes) is called when a chip is clicked.
   */
  function makeChips(containerId, items, selectedArr, onToggle) {
    var el = document.getElementById(containerId);
    if (!el) return;
    el.innerHTML = '';
    var nonAllCodes = items
      .filter(function(it) { return it.code !== 'ALL'; })
      .map(function(it)    { return it.code; });
    var allSelected = nonAllCodes.length > 0 &&
      nonAllCodes.every(function(c) { return selectedArr.indexOf(c) !== -1; });

    items.forEach(function(item) {
      var btn      = document.createElement('button');
      var isAllChip = item.code === 'ALL';
      var isActive  = isAllChip ? allSelected : selectedArr.indexOf(item.code) !== -1;
      btn.className = 'se-chip' + (isAllChip ? ' all-chip' : '') + (isActive ? ' active' : '');
      btn.textContent = item.label;
      btn.onclick = function() { onToggle(item.code, nonAllCodes); };
      el.appendChild(btn);
    });
  }

  function show(id, visible) {
    var el = document.getElementById(id);
    if (el) el.style.display = visible ? '' : 'none';
  }

  // ---- RENDER -----------------------------------------------

  function render() {

    // Construction type
    makeChips('project-chips', PROJECTS, selProjects, function(code, nonAll) {
      toggle(selProjects, code, nonAll);
      // Drop any walls that are no longer valid for the new project selection
      var validWalls = getActiveWalls()
        .filter(function(w) { return w.code !== 'ALL'; })
        .map(function(w)    { return w.code; });
      for (var i = selWalls.length - 1; i >= 0; i--) {
        if (validWalls.indexOf(selWalls[i]) === -1) selWalls.splice(i, 1);
      }
      render();
    });

    // Wall type
    show('wall-step', selProjects.length > 0);
    if (selProjects.length > 0) {
      var activeWalls    = getActiveWalls();
      var wallNonAll     = activeWalls.filter(function(w) { return w.code !== 'ALL'; }).map(function(w) { return w.code; });
      makeChips('wall-chips', activeWalls, selWalls, function(code) {
        toggle(selWalls, code, wallNonAll);
        render();
      });
    }

    // Location
    show('loc-step', selWalls.length > 0);
    if (selWalls.length > 0) {
      var locNonAll = LOCS.filter(function(l) { return l.code !== 'ALL'; }).map(function(l) { return l.code; });
      makeChips('loc-chips', LOCS, selLocs, function(code) {
        toggle(selLocs, code, locNonAll);
        // If ROOF was removed, clear downstream roof selections
        if (selLocs.indexOf('ROOF') === -1) {
          selConfigs.splice(0, selConfigs.length);
          selAssemblies.splice(0, selAssemblies.length);
        }
        render();
      });
    }

    // Roof configuration (only when ROOF is among selected locations)
    var hasRoof = selLocs.indexOf('ROOF') !== -1;
    show('config-step', hasRoof);
    if (hasRoof) {
      var configNonAll = CONFIGS.filter(function(c) { return c.code !== 'ALL'; }).map(function(c) { return c.code; });
      makeChips('config-chips', CONFIGS, selConfigs, function(code) {
        toggle(selConfigs, code, configNonAll);
        // If no non-flat configs remain, clear assembly selections
        var hasNonFlat = selConfigs.some(function(c) { return c !== '5'; });
        if (!hasNonFlat) selAssemblies.splice(0, selAssemblies.length);
        render();
      });
    }

    // Roof assembly (only when at least one non-Flat config selected)
    var hasNonFlatConfig = selConfigs.some(function(c) { return c !== '5'; });
    var showAssembly     = hasRoof && hasNonFlatConfig;
    show('assembly-step', showAssembly);
    if (showAssembly) {
      var asmNonAll = ASSEMBLIES.filter(function(a) { return a.code !== 'ALL'; }).map(function(a) { return a.code; });
      makeChips('assembly-chips', ASSEMBLIES, selAssemblies, function(code) {
        toggle(selAssemblies, code, asmNonAll);
        render();
      });
    }

    // File format (appears once detail selection is complete)
    var detailComplete = isDetailComplete();
    show('format-step', detailComplete);
    if (detailComplete) {
      var fmtNonAll = ['PDF', 'DWG'];
      makeChips('format-chips', FORMATS, selFormats, function(code) {
        toggle(selFormats, code, fmtNonAll);
        render();
      });
    }

    // Add row
    show('add-row', detailComplete && selFormats.length > 0);

    // Preview text
    var previewEl = document.getElementById('preview-text');
    if (previewEl) {
      if (detailComplete && selFormats.length > 0) {
        var codes = generateCodes();
        var count = codes.length * selFormats.length;
        if (count === 1) previewEl.textContent = codes[0] + ' (' + selFormats[0] + ')';
        else             previewEl.textContent = count + ' details will be added';
      } else {
        previewEl.textContent = '';
      }
    }

    var btnAdd = document.getElementById('btn-add');
    if (btnAdd) btnAdd.disabled = !isAddable();

    renderResults();
  }

  // ---- RENDER RESULTS ---------------------------------------

  function renderResults() {
    var list       = document.getElementById('links-list');
    var empty      = document.getElementById('empty-msg');
    var countLabel = document.getElementById('count-label');
    countLabel.textContent = results.length + ' detail' + (results.length === 1 ? '' : 's');
    show('contact-form', results.length > 0);
    updateSendBtn();
    document.getElementById('btn-clear').style.display = results.length > 0 ? '' : 'none';
    empty.style.display = results.length === 0 ? '' : 'none';
    list.querySelectorAll('.se-link-row').forEach(function(el) { el.parentNode.removeChild(el); });
    results.forEach(function(entry, idx) {
      var baseCode = getBaseCode(entry);
      var fmt      = getFormat(entry);
      var row    = document.createElement('div');    row.className = 'se-link-row';
      var label  = document.createElement('span');   label.className = 'se-detail-label'; label.textContent = getCodeLabel(baseCode);
      var cspan  = document.createElement('span');   cspan.className = 'se-detail-code';  cspan.textContent = baseCode + (fmt ? ' (' + fmt + ')' : '');
      var spacer = document.createElement('span');   spacer.className = 'se-detail-spacer';
      var rm     = document.createElement('button'); rm.className = 'se-remove-btn'; rm.textContent = '×'; rm.title = 'Remove';
      rm.onclick = (function(i) { return function(e) { e.preventDefault(); var sy = window.scrollY || window.pageYOffset; results.splice(i, 1); renderResults(); window.scrollTo(0, sy); }; })(idx);
      row.appendChild(label); row.appendChild(cspan); row.appendChild(spacer); row.appendChild(rm);
      list.appendChild(row);
    });
  }

  // ---- EMAIL ------------------------------------------------

  function buildEmailHTML(contact) {
    var itemsHTML = '';
    results.forEach(function(entry) {
      var baseCode = getBaseCode(entry);
      var fmt      = getFormat(entry);
      var url      = 'https://www.475.supply/' + baseCode;
      var linkText = getCodeLabel(baseCode) + ' &mdash; ' + baseCode + (fmt ? ' (' + fmt + ')' : '');
      itemsHTML += '<li style="margin-bottom:10px;"><a href="' + url + '" style="color:#0062A8;text-decoration:none;font-family:Helvetica,Arial,sans-serif;font-size:14px;">' + linkText + '</a></li>';
    });
    return '<!DOCTYPE html><html><head><meta charset="UTF-8"></head><body style="margin:0;padding:20px;background:#f4f4f4;">'
      + '<table width="620" cellpadding="0" cellspacing="0" border="0" style="margin:0 auto;background:#ffffff;font-family:Helvetica,Arial,sans-serif;">'
      + '<tr><td style="background:#0062A8;height:8px;border-radius:4px 4px 0 0;font-size:0;line-height:0;">&nbsp;</td></tr>'
      + '<tr><td style="padding:24px 36px 16px;"><table width="100%" cellpadding="0" cellspacing="0" border="0" style="border-bottom:1px solid #ECEDF2;padding-bottom:16px;"><tr>'
      + '<td width="44" valign="middle"><img src="https://www.jotform.com/uploads/Bernstein_Rachel/form_files/8169c72e2d1d1e8d239aa0190bcec10e.6378075bb08a04.84981966.png" width="44" height="42" alt="475 Supply" /></td>'
      + '<td valign="middle" style="padding-left:10px;"><span style="font-size:16px;font-weight:bold;color:#0a1551;letter-spacing:0.04em;font-family:Helvetica,Arial,sans-serif;">SMART ENCLOSURE FILE DOWNLOADS</span></td>'
      + '</tr></table></td></tr>'
      + '<tr><td style="padding:8px 36px 24px;">'
      + '<p style="margin:0 0 14px;font-size:14px;color:#1a1a1a;line-height:1.7;font-family:Helvetica,Arial,sans-serif;">Hi there,</p>'
      + '<p style="margin:0 0 14px;font-size:14px;color:#1a1a1a;line-height:1.7;font-family:Helvetica,Arial,sans-serif;">Thank you for your interest in the Smart Enclosure. The Smart Enclosure system offers 21st century guidance for creating assemblies that reduce toxicity, embodied carbon, and moisture risk while remaining durable, airtight, energy efficient, simple, and cost-effective.</p>'
      + '<p style="margin:0 0 20px;font-size:14px;color:#1a1a1a;line-height:1.7;font-family:Helvetica,Arial,sans-serif;">A 475 team member will follow up with you soon. If your needs are urgent, please reach out by replying to this email or by phone during regular business hours.</p>'
      + '<table width="100%" cellpadding="0" cellspacing="0" border="0" style="background:#f7f9fc;border:1px solid #ECEDF2;margin-bottom:20px;"><tr><td style="padding:20px 24px;">'
      + '<p style="margin:0 0 4px;font-size:13px;font-weight:bold;color:#0a1551;font-family:Helvetica,Arial,sans-serif;text-transform:uppercase;letter-spacing:0.05em;">Your Selected Details</p>'
      + '<p style="margin:0 0 14px;font-size:11px;color:#888;font-style:italic;font-family:Helvetica,Arial,sans-serif;line-height:1.5;">These downloads are diagrammatic and are not intended for direct use. A professional architect, engineer, or builder must evaluate and customize per specific project requirements.</p>'
      + '<ul style="margin:0;padding-left:20px;">' + itemsHTML + '</ul>'
      + '</td></tr></table>'
      + '<p style="margin:0 0 4px;font-size:12px;color:#999;font-family:Helvetica,Arial,sans-serif;">Sent to: <strong style="color:#555;">' + contact.first + ' ' + contact.last + ' &lt;' + contact.email + '&gt;</strong></p>'
      + '<p style="margin:0 0 4px;font-size:12px;color:#999;font-family:Helvetica,Arial,sans-serif;">Phone: <strong style="color:#555;">' + contact.phone + '</strong> &nbsp;&bull;&nbsp; Company: <strong style="color:#555;">' + contact.company + '</strong></p>'
      + '<p style="margin:0 0 4px;font-size:12px;color:#999;font-family:Helvetica,Arial,sans-serif;">State: <strong style="color:#555;">' + contact.state + '</strong> &nbsp;&bull;&nbsp; Role: <strong style="color:#555;">' + contact.role + '</strong></p>'
      + '</td></tr>'
      + '<tr><td style="padding:14px 36px;border-top:1px solid #ECEDF2;">'
      + '<p style="margin:0 0 4px;font-size:12px;color:#999;font-family:Helvetica,Arial,sans-serif;">475 High Performance Building Supply &nbsp;&bull;&nbsp; <a href="https://www.475.supply" style="color:#0062A8;text-decoration:none;">www.475.supply</a> &nbsp;&bull;&nbsp; 800-995-6329</p>'
      + '<p style="margin:0;font-size:11px;color:#bbb;font-style:italic;font-family:Helvetica,Arial,sans-serif;">Build Like the Future Depends on It&trade;</p>'
      + '</td></tr></table></body></html>';
  }

  function showDraft(contact) {
    var html = buildEmailHTML(contact);
    document.getElementById('_email_html_store').value = html;
    var draftBody = document.getElementById('draft-body');
    draftBody.innerHTML = '';
    var iframe = document.createElement('iframe');
    iframe.style.cssText = 'width:100%;border:none;min-height:480px;display:block;';
    draftBody.appendChild(iframe);
    var doc = iframe.contentDocument || iframe.contentWindow.document;
    doc.open(); doc.write(html); doc.close();
    setTimeout(function() { iframe.style.height = (doc.body.scrollHeight + 40) + 'px'; }, 250);
    var draftBox = document.getElementById('draft-box');
    draftBox.style.display = 'block';
    draftBox.scrollIntoView({ behavior:'smooth', block:'nearest' });
    document.getElementById('copy-btn').textContent = 'Copy HTML';
    document.getElementById('copy-btn').classList.remove('copied');
  }

  // ---- INIT -------------------------------------------------

  function init() {
    if (!document.getElementById('project-chips')) { setTimeout(init, 30); return; }

    // Add to Download List
    document.getElementById('btn-add').addEventListener('click', function() {
      if (!isAddable()) return;
      var codes = generateCodes();
      for (var fi = 0; fi < selFormats.length; fi++) {
        var fmt = selFormats[fi];
        for (var ci = 0; ci < codes.length; ci++) {
          var entry = codes[ci] + '::' + fmt;
          if (results.indexOf(entry) === -1) results.push(entry);
        }
      }
      render();
    });

    // Complete Download Form — scroll & focus First Name field
    document.getElementById('btn-goto-form').addEventListener('click', function() {
      var el = document.getElementById('field-first');
      if (el) {
        el.scrollIntoView({ behavior:'smooth', block:'center' });
        setTimeout(function() { el.focus(); }, 400);
      }
    });

    // Clear all
    document.getElementById('btn-clear').addEventListener('click', function() {
      results = [];
      selProjects = []; selWalls = []; selLocs = [];
      selConfigs  = []; selAssemblies = []; selFormats = [];
      FORM_FIELDS.forEach(function(id) { var el = document.getElementById(id); if (el) el.value = ''; });
      document.getElementById('draft-box').style.display = 'none';
      render();
    });

    // Send to my email
    document.getElementById('btn-send').addEventListener('click', function() {
      var contact = {
        first:   document.getElementById('field-first').value.trim(),
        last:    document.getElementById('field-last').value.trim(),
        email:   document.getElementById('field-email').value.trim(),
        phone:   document.getElementById('field-phone').value.trim(),
        company: document.getElementById('field-company').value.trim(),
        state:   document.getElementById('field-state').value,
        role:    document.getElementById('field-role').value
      };
      if (!contact.first||!contact.last||!contact.email||!contact.phone||!contact.company||!contact.state||!contact.role||results.length===0) return;
      var btn = document.getElementById('btn-send');
      btn.disabled = true; btn.textContent = 'Sending...';
      if (!APPS_SCRIPT_URL || APPS_SCRIPT_URL === 'YOUR_APPS_SCRIPT_URL_HERE') {
        showDraft(contact); btn.disabled = false; btn.textContent = 'Send to my email'; updateSendBtn(); return;
      }
      fetch(APPS_SCRIPT_URL, { method:'POST', headers:{'Content-Type':'text/plain'}, body:JSON.stringify({contact:contact, codes:results}) })
        .then(function(res) { return res.json(); })
        .then(function()    { showDraft(contact); btn.disabled = false; btn.textContent = 'Send to my email'; updateSendBtn(); })
        .catch(function()   { showDraft(contact); btn.disabled = false; btn.textContent = 'Send to my email'; updateSendBtn(); });
    });

    // Form field listeners for Send button state
    ['field-first','field-last','field-email','field-phone','field-company'].forEach(function(id) {
      var el = document.getElementById(id); if (el) el.addEventListener('input', updateSendBtn);
    });
    ['field-state','field-role'].forEach(function(id) {
      var el = document.getElementById(id); if (el) el.addEventListener('change', updateSendBtn);
    });

    // Copy HTML button
    document.getElementById('copy-btn').addEventListener('click', function() {
      var html = document.getElementById('_email_html_store').value;
      navigator.clipboard.writeText(html).then(function() {
        document.getElementById('copy-btn').textContent = 'Copied!';
        document.getElementById('copy-btn').classList.add('copied');
        setTimeout(function() {
          document.getElementById('copy-btn').textContent = 'Copy HTML';
          document.getElementById('copy-btn').classList.remove('copied');
        }, 2500);
      }).catch(function() {
        var s = document.getElementById('_email_html_store');
        s.style.display = 'block'; s.select();
      });
    });

    render();
  }

  init();

})();
